module.exports = __webpack_public_path__ + "static/Ro100-cfd3fe40ef83d3bff7989276837428b0.png";